import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import { useHistory } from 'react-router-dom';
import { Tab } from 'semantic-ui-react';
import isParentOrganization from 'helpers/isParentOrganization';
import getUserRoles from 'helpers/getUserRoles';
import {
  isFinanceRwandaAdmin,
  isLoanAdmin,
  isLoanOfficer,
  isOrgAdmin,
  isRwandaAdmin,
  isSA,
  isSSA,
  isSupportAdmin,
  isSupportUser,
} from 'helpers/checkRoles';
import OrganizationWallet from './OrganizationWallet';
import GroupWallet from './GroupWallet';
import IndividualWallet from './IndividualWallet';

const panes = props => [
  {
    key: 'organization',
    menuItem: 'Organization wallets',
    render: () => <OrganizationWallet props={props} />,
  },
  {
    key: 'group',
    menuItem: 'Group wallets',
    render: () => <GroupWallet props={props} />,
  },
  {
    key: 'individual',
    menuItem: 'Individual wallets',
    render: () => <IndividualWallet props={props} />,
  },
];

const Wallet = ({ location, history, match }) => {
  const { push } = useHistory();
  const isCurrentOrgParent = isParentOrganization();
  const { roles } = getUserRoles();
  const isSupportUserRole = isSupportUser(roles) || isSA(roles);
  const isAdmin =
    isFinanceRwandaAdmin(roles) ||
    isRwandaAdmin({ roles }) ||
    isOrgAdmin(roles) ||
    isSSA(roles);
  const isLoanAdminRole = isLoanAdmin(roles);
  const isLoanOfficerRole = isLoanOfficer(roles);

  const {
    params: { tab },
  } = match;

  const filteredPanes = panes({ location, history, match }).filter(
    ({ key }) =>
      (key === 'organization' && isAdmin && !isSupportAdmin(roles)) ||
      (key === 'group' &&
        (isSupportUserRole ||
          isAdmin ||
          isSupportAdmin(roles) ||
          isLoanAdminRole ||
          isLoanOfficerRole)) ||
      (key === 'individual' &&
        (isSupportUserRole ||
          isAdmin ||
          isSupportAdmin(roles) ||
          isLoanAdminRole ||
          isLoanOfficerRole)),
  );

  const activeIndex = Math.max(
    0,
    filteredPanes.findIndex(pane => pane.key === tab),
  );

  const handleTabChange = (_e, { activeIndex: newIndex }) => {
    const pane = filteredPanes[newIndex];
    if (pane) {
      push(`/wallets/${pane.key}`);
    }
  };

  if (!isCurrentOrgParent) {
    return (
      <OrganizationWallet props={{ location, history, match }} />
    );
  }

  return (
    <div className="wallet-tab-items">
      <Tab
        activeIndex={activeIndex}
        menu={{ secondary: true, pointing: true }}
        panes={filteredPanes}
        onTabChange={handleTabChange}
      />
    </div>
  );
};

Wallet.propTypes = {
  location: PropTypes.objectOf(Object).isRequired,
  history: PropTypes.objectOf(Object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.oneOfType([PropTypes.object]),
  }).isRequired,
};

export default Wallet;
